import { Rating } from 'components/rating';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import React, { FunctionComponent } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { formatDateTime } from 'utils';
import { capitalizeName } from 'utils/capitalize';
import { Review } from '../types/review.type';
import { ReviewMeta } from './ReviewMeta';

type ReviewMetaLineProps = {
  review: Review;
};

export const ReviewMetaLine: FunctionComponent<ReviewMetaLineProps> = ({
  review,
}) => (
  <ReviewMeta>
    {review.rating ? (
      <span>
        <Rating
          value={review.rating}
          color={review.ratingType === 'ia' ? 'green' : '#fbbd08'}
        />
        {review.ratingType === 'ia' ? ' (note automatique)' : null}
      </span>
    ) : (
      <Label size="small">Aucune note</Label>
    )}
    <span>
      <Icon name="calendar alternate outline" />
      {review.dateCreated ? formatDateTime(review.dateCreated) : '—'}
    </span>
    {review.lastModifiedAt ? (
      <span>
        <Icon name="pencil" />
        Modifié le {formatDateTime(review.lastModifiedAt)}
      </span>
    ) : null}
    {review.dateOfWork ? (
      <span>
        <Icon name="wrench" />
        Prestation réalisée en{' '}
        {capitalizeName(
          format(new Date(review.dateOfWork), 'MMMM yyyy', { locale: fr }),
        )}
      </span>
    ) : null}
  </ReviewMeta>
);
